<template>
    <el-drawer :title="data ? '编辑密码' : '新增演出'" :visible.sync="drawerShow" :wrapperClosable="false"
        :destroy-on-close="true" size="auto" @close="close" append-to-body>
        <div class="drawer-content">
            <el-form :model="formData" ref="formData" label-position="top" size="medium" :rules="rules">
                <template v-if="!data">
                    <el-form-item prop="activityId" label="演出ID:">
                        <el-input v-model.trim="formData.activityId" oninput="value=value.replace(/[^\d]/g,'')" placeholder="请填写演出ID"></el-input>
                    </el-form-item>
                    <el-form-item prop="sessionId" label="场次ID:">
                        <el-input v-model.trim="formData.sessionId" oninput="value=value.replace(/[^\d]/g,'')" placeholder="请填写场次ID"></el-input>
                    </el-form-item>
                </template>
                <el-form-item v-else>
                    <span slot="label">当前密码: {{data.pwd}}</span>
                </el-form-item>
                <el-form-item prop="pwd" label="设置密码:">
                    <el-input v-model="formData.pwd" placeholder="请填写密码" :minlength="6"></el-input>
                </el-form-item>
               <el-form-item prop="expireTime">
               	<span slot="label">看板数据保留时间：<small class="from-tip color-warning"><span
               				class="el-icon-warning"></span> 默认演出结束后72小时</small></span>
               	<el-input-number style="width:88%" v-model="formData.expireTime" :precision="0"
               		controls-position="right" :min="24" :max="17280" size="medium"
               		placeholder="请填写看板数据保留时间"></el-input-number> 小时
               </el-form-item>
            </el-form>
        </div>
        <div class="drawer-footer">
            <el-button @click="close">取 消</el-button>
            <el-button type="primary" @click="submitForm()" :loading="btnLoading">确 定</el-button>
        </div>
    </el-drawer>
</template>

<script>
const defaultFormData = {
    activityId: "",
    pwd: "",
    sessionId: "",
	expireTime:72
}
export default {
    data() {
        var checkPw = (rule, value, callback) => {
            if (value && value.length < 6) {
                return callback(new Error('至少输入6位'));
            }else{
                callback();
            }
        };
        return {
            drawerShow: false,
            btnLoading: false,
            formData: { ...defaultFormData },
            rules: {
                activityId: [{ required: true, message: "请填写演出ID" }],
                sessionId: [{ required: true, message: "请填写场次ID" }],
                pwd: [{ validator: checkPw ,required: true, message: "请填写密码" }]
            },
            data: null
        }
    },
    methods: {
        show(data) {
            this.data = data || null;
            this.formData = {
                ...defaultFormData,
                activityId: data && data.activityId || "",
                sessionId: data && data.sessionId || "",
				expireTime: data && data.expireTime || 72,
				id:data && data.id || ''
            }
            if (this.$refs.formData) {
                this.$refs.formData.clearValidate();
            }
            this.drawerShow = true;
        },
        close() {
            if (this.$refs.formData) {
                this.$refs.formData.clearValidate();
            }
            this.drawerShow = false;
        },
        submitForm() {
            this.$refs["formData"].validate(async (valid) => {
                if (valid) {
                    this.btnLoading = true;
                    this.$request({
                        url: '/daping/invite/update',
                        data: {
                            ...this.formData,
                            pwd: this.formData.pwd
                        },
                        method: "post",
                    })
                        .then((res) => {
                            const { state, msg } = res.data;
                            if (state == 1) {
                                this.$emit('onUpdate');
                                this.close();
                            } else {
                                this.$message.error(msg || "操作失败,请重试");
                            }
                        })
                        .catch(() => {
                            this.$message.error("操作失败,请重试");
                        })
                        .finally(() => {
                            this.btnLoading = false;
                        });
                }
            })
        }
    }
}
</script>

<style lang="scss" scoped>
	::v-deep .el-form-item__label small {
		color: #E6A23C
	}
</style>